import type { PortalMe } from '@central/api';
import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from '@tanstack/react-router';
import { meQuery } from './api';

/** Starts the new session: nothing cached before this sign-in belongs to it. */
export function useSignedIn() {
  const qc = useQueryClient();
  const navigate = useNavigate();
  return (me?: PortalMe) => {
    qc.clear();
    if (me) qc.setQueryData(meQuery.queryKey, me);
    void navigate({ to: '/' });
  };
}
